import React from 'react';
import './Loader.less';

export default () => {
  return (

<svg preserveAspectRatio="xMinYMid slice" viewBox="0 0 800 600">
  <g id="comets">
    <line x1="1185" x2="77.5" y1="-15" y2="1092.5"></line>
    <line x1="854" x2="163" y1="8" y2="699"></line>
    <line x1="573" x2="-49.5" y1="-33" y2="589.5"></line>
    <line x1="271" x2="-60.5" y1="-33" y2="298.5"></line>
    <line x1="463" x2="-102" y1="-76" y2="489"></line>
    <line x1="120" x2="-26" y1="-19" y2="127"></line>
    <line x1="866" x2="305.6" y1="174.3" y2="734.7"></line>
    <line x1="854" x2="653" y1="462" y2="663"></line>
  </g>
  <g id="rocket">
    <path d="M445.3,256.3c-47.3-3.5-62.8,27-62.8,27c-18.5,2-24,10-24,10l15.5,12.3c-0.5,15.3,3.5,16.5,3.5,16.5c5.5,7.5,17.8,4.8,17.8,4.8l12.8,17c12-12.5,10.3-25.5,10.3-25.5C450.8,300,445.3,256.3,445.3,256.3zM416.3,297c-6.5,0-11.8-5.3-11.8-11.8c0-6.5,5.3-11.8,11.8-11.8s11.8,5.3,11.8,11.8C428,291.7,422.7,297,416.3,297z"></path>
    <circle></circle>
    <polygon points="371.3,338.6 355.7,344.7 363.1,329.7"></polygon>
  </g>
</svg>
  );
};


/** WEBPACK FOOTER **
 ** ./src/js/app/App/Loader.jsx
 **/